import api from './api';

export function getExtracts() {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/stratums`);
}

export function getContractTypes(actividad) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/clients/type-contract/${actividad}`);
}
